export {WithProperties} from "MWL@2026/core/Reactive/PropertySystem/Properties/WithProperties";

export {updateProperties} from "MWL@2026/core/Reactive/PropertySystem/Properties/PropertiesProvider";
export {bindProperties} from "MWL@2026/core/Reactive/PropertySystem/Properties/sync";

export {PropertiesEffects} from "MWL@2026/core/Reactive/PropertySystem/Properties/PropertiesEffects";

export {type PropertiesDescriptors} from "MWL@2026/core/Reactive/PropertySystem/Properties/PropertiesImpl";

/*
export {createPropertiesFactory} from "MWL@2026/core/Reactive/Properties/Properties/createProperties";
/*
export {type PropertiesDescriptors, type GetPropertiesType, type Properties} from "MWL@2026/core/Reactive/Properties/Properties/PropertiesImpl";
export {type PropertiesProvider, getProperties, updateProperties} from "MWL@2026/core/Reactive/Properties/Properties/PropertiesProvider";

export {PropertiesRenderer} from "MWL@2026/core/Reactive/Properties/Properties/PropertiesRenderer";
*/

export * as controllers from "./controllers";
//export * as sync        from "./sync";